import {
  CmpTextField,
  CmpTextFieldEnter,
  CmpSelectBox,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";

import { Button } from "@mui/material";
export default function WmsContent({
  xref,
  sEnterKeyObj,
  vMediaQuery,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,
  vRdxHead,
  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fCardId,
  fCardIdEnter,
  fItemName,

  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  //customer
  xfGC_Toggle_Head_BinName_Name,
  xGC_Toggle_Head_BinName_Toggle = false,
  xGC_Toggle_Head_BinName_onKeyUp,
  xGC_Toggle_Head_BinName_SearchDropdownObj,
  xGC_Toggle_Head_BinName_Dropdown_onChange,
  xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_GridData,
  xfGC_Toggle_Head_BinName_OnRowClick,
  xfGC_Toggle_Head_BinName_OnCellKeyDown,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //customer end
}) {
  const buttonStyleBin = {
    background: 'orange',
    borderRadius: '20px',
    padding: '1px 17px',
    color: 'white', 
    textTransform: 'none',    
   minWidth:'-webkit-fill-available' 
    // '@media (max-width: 768px)': { // Adjust the max-width as per your mobile screen size
    //   fontSize: '10px !important'// Set the font size for mobile screens
    // }
  };
  const buttonStyleRef = {
    background: 'red',
    borderRadius: '20px',
    padding: '1px 17px',
    color: 'white', 
    textTransform: 'none',    
   minWidth:'-webkit-fill-available' 
    // '@media (max-width: 768px)': { // Adjust the max-width as per your mobile screen size
    //   fontSize: '10px !important'// Set the font size for mobile screens
    // }
  };
  return (
    <form
      className="Wms-inbound-grn-content mt-2"
      id="WmsStockAdjustmentContent"
    >
      <Grid container spacing={1.2} columns={{ xs: 12, sm: 12, md: 12 }}>
        {/* <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Bin No"}
            xVariant={"standard"}
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BinCode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinCode}
          />
        </Grid> */}
        <Grid
          container
          spacing={0}
          columns={{ xs: 12, sm: 12, md: 12 }}
          className="mb-1 justify-content-between buttonstyle"
        >
          <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
           
            <Button size="small" style={buttonStyleRef}>
              SheetNo &nbsp; &nbsp; {vRdxHead?.sheetID}
            </Button>
          </Grid>
          <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
          
            <Button style={buttonStyleBin}>
              AssignBin &nbsp; &nbsp;{vRdxHead?.binName}
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CmpTextFieldEnter
          xref={xref}
            xtabIndex="103"
            xLabelText={"Bin Name"}
            xVariant={"standard"}
            xValue={xBufferObj.B_BinName}
            xOnChange={xfGC_Toggle_Head_BinName_Name}
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp}
            xReadOnly={false}
            xType={"text"}
            xName={"GC_Toggle_Head_BinName_Name"}
            xError={xErrorMsgDetail.B_BinName === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_BinName}
            xErrorMessage={""}
            xOnEnter={(e) => {
              xGC_Toggle_Head_BinName_onKeyUp(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        {/* <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Sr.No"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
          />
        </Grid> */}
        <Grid item xs={12}>
          <CmpTextFieldEnter
            xLabelText={"Card ID"}
            xVariant={"standard"}
            xValue={xBufferObj.B_CardId}
            xType={"text"} // text/number/password
            xName={"B_CardId"}
            xReadOnly={false}
            xOnChange={fCardId}
            xError={xErrorMsgDetail.B_CardId === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_CardId}
            xErrorMessage={""}
            xtabIndex={"101"}
            xOnKeyUp={fCardIdEnter}
            xOnEnter={(e) => {
              fCardIdEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>

        {/* <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Item Code"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          />
        </Grid> */}
        <Grid item xs={12}>
          <CmpTextField
            xLabelText={"Item Name"}
            xVariant={"standard"}
            xValue={xBufferObj?.B_ItmName}
            xOnChange={fItemName}
            xReadOnly={true}
            xType={"text"}
            xName={"B_ItmName"}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_ItmName}
            xErrorMessage={""}
            xtabIndex={"102"}
          />
        </Grid>

        <Grid item xs={4}>
          <CmpTextField
          xTextAlign="center"
            xLabelText={"Qty"}
            xVariant={"standard"}
            xtabIndex={"104"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_Qty}
            xErrorMessage={""}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpSelectBox
            xtabIndex={"105"}
            xLabelText="Unit"
            xVariant={"standard"}
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_Unit}
            xErrorMessage={""}
            xDisable={false}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Packing"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_Packing}
            xType={"text"} // text/number/password
            xName={"B_Packing"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Packing === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_Packing}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpTextField
            xLabelText={"Base Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BaseQty === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail.B_BaseQty}
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Reference No"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.SuppRefNo1}
            xType={"text"} // text/number/password
            xName={"SuppRefNo1"}
            xReadOnly={true}
            xOnChange={""}
            xError={  false }
            xErrorMessage={""}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"BarCode"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.BarCode}
            xType={"text"} // text/number/password
            xName={"BarCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={  false }
            xErrorMessage={""}
          />
        </Grid>
      </Grid>
    </form>
  );
}
